module.exports = __webpack_public_path__ + "img/basico3.fw.cb0fa3f6.png";